import { useCallback, useState } from "react";
import useProfileStore from "../../store/patient/profileStore";
import { fetchRadiology } from "../../utils/patients/fetchRadiology";
import { fetchAllRadiologyTest } from "../../utils/patients/fetchAllRadiologyTest";
import { QueryRadiologyRequest } from "../../utils/patients/querryRadiologyTest";
import { sendRadiologyRequest } from "../../utils/patients/createRadiologyRequest";

const useManageRadiology = () => {
  const normalizeTestsResponse = (payload, fallbackPage = 1, fallbackLimit = 8) => {
    const items = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.result)
      ? payload.result
      : Array.isArray(payload?.items)
      ? payload.items
      : Array.isArray(payload?.data)
      ? payload.data
      : [];

    const page =
      payload?.page ??
      payload?.currentPage ??
      payload?.meta?.page ??
      fallbackPage;
    const limit =
      payload?.limit ??
      payload?.per_page ??
      payload?.meta?.limit ??
      fallbackLimit;

    return {
      items,
      page,
      limit,
      hasNextPage: items.length === limit,
    };
  };

  const [loading, setLoading] = useState(false);
  const { profile } = useProfileStore();
  const [radiology, setRadiology] = useState([]);
  const [tests, setTests] = useState({
    items: [],
    page: 1,
    limit: 8,
    hasNextPage: false,
  });

  const handleFechRadiology = useCallback(async () => {
    setLoading(true);
    await fetchRadiology(profile?.id)
      .then((res) => {
        setLoading(false);
        setRadiology(res?.data?.result);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [profile?.id]);

  const handleFechAllTest = useCallback(async ({ q = "", limit = 8, page = 1 } = {}) => {
    setLoading(true);
    await fetchAllRadiologyTest({ q, limit, page })
      .then((res) => {
        setLoading(false);
        setTests(normalizeTestsResponse(res?.data, page, limit));
      })
      .catch(() => {
        setLoading(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
        localStorage?.setItem("user", null);
      });
  }, []);

  const handleQueryTest = useCallback(async ({ q = "", limit = 8, page = 1 } = {}) => {
    setLoading(true);
    await QueryRadiologyRequest({ q, limit, page })
      .then((res) => {
        setLoading(false);
        setTests(normalizeTestsResponse(res?.data, page, limit));
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleSubmitRequest = useCallback(async (data) => {
    try {
      const response = await sendRadiologyRequest(data);
      return response;
    } catch (err) {
      console.log(err);
      // window.location.href = "/pages/signin2";
        console.log("error error");
      // localStorage?.setItem("user", null)
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    handleFechAllTest,
    handleFechRadiology,
    handleQueryTest,
    radiology,
    tests,
    handleSubmitRequest,
  };
};

export default useManageRadiology;
